import { addLocaleData } from 'react-intl';
import {get} from 'lodash';

const importIntlPolyfillLocaleData = (locale) => {
  switch (locale) {
    case 'de-de':
      return import(/* webpackChunkName: "intl_polyfill_de" */ 'intl/locale-data/jsonp/de.js');
    case 'fr-fr':
      return import(/* webpackChunkName: "intl_polyfill_fr" */ 'intl/locale-data/jsonp/fr.js');
    default:
      return import(/* webpackChunkName: "intl_polyfill_en" */ 'intl/locale-data/jsonp/en.js');
  }
};

const importReactIntlLocaleData = (locale) => {
  switch (locale) {
    case 'de-de':
      return import(/* webpackChunkName: "react_intl_de" */ 'react-intl/locale-data/de.js');
    case 'fr-fr':
      return import(/* webpackChunkName: "react_intl_fr" */ 'react-intl/locale-data/fr.js');
    default:
      return import(/* webpackChunkName: "react_intl_en" */ 'react-intl/locale-data/en.js');
  }
};

const importDateFnsLocaleData = (locale) => {
  switch (locale) {
    case 'de-de':
      return import(/* webpackChunkName: "date_fns_de" */ 'date-fns/locale/de');
    case 'fr-fr':
      return import(/* webpackChunkName: "date_fns_fr" */ 'date-fns/locale/fr');
    default:
      return Promise.resolve({ default: null });
  }
};

const addReactIntlLocaleData = (locale) =>
  importReactIntlLocaleData(locale)
    .then(({ default: localeData }) => {
      addLocaleData(localeData);
    });

const polyfillIntl = (locale, theWindow) =>
  /*
   * Q: Why are we importing `intl/lib/core` instead of just `intl`?
   *
   * A: `intl/index.js` does too much -- aside from exporting the same
   * thing as `intl/lib/core`, it also tries to do some extra
   * polyfilling. There's also a risk that it's loading more locale data
   * than necessary. It seems safer to just perform the polyfill ourselves.
   * This also makes this logic easier to unit test, by stubbing out
   * `window`).
   */
  import(/* webpackChunkName: "intl" */ 'intl/lib/core')
    .then(({ default: IntlPolyfill }) => {
      theWindow.IntlPolyfill = IntlPolyfill;
      theWindow.Intl = IntlPolyfill;
    })
    .then(() => importIntlPolyfillLocaleData(locale));

export default (
  store,
  theWindow = window // Don't pass this in on prod; only for stubbing
  // `window` in unit testing.
) => {
  const locale = get(store.getState(), 'i18n.locale');
  if (!locale) {
    throw new Error(
      'Could not run a few i18n-related bootstrap functions.'
      + ' store.getState().i18n.locale was not present.'
    );
  }

  const firstStep = theWindow.Intl
    ? Promise.resolve()
    : polyfillIntl(locale, theWindow);
  return firstStep
    .then(() => addReactIntlLocaleData(locale))
    .then(() => importDateFnsLocaleData(locale))
    .then(({ default: dateFnsLocale }) => {
      theWindow.__dateFnsLocales__ = {};
      if (!dateFnsLocale) {
        return;
      }
      theWindow.__dateFnsLocales__[locale] = dateFnsLocale;
    });
};
